import { I18n } from "@assets/strings";
import React, { JSX } from "react";
import styled from "styled-components";
import { Diploma } from "@domain/organization/track/diploma";
import { Primary, PrimaryMedium } from "@ui/components/containers/primary";
import { MapIcon, ProPageIcon, TimeIcon } from "@ui/components/icons";
import { Row, row, stack } from "@ui/components/layout";
import { desktop, mobile } from "@ui/styles/utils";

interface DiplomaInfosProps extends React.HTMLAttributes<HTMLDivElement> {
	diploma: Diploma;
}
export const DiplomaInfos: React.FC<DiplomaInfosProps> = ({ diploma, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			{diploma.duration ? (
				<Info title={I18n.t("organization.diploma.duration.label")} icon={<TimeIcon />} value={diploma.duration} />
			) : null}
			<Info
				title={I18n.t("organization.diploma.type.label")}
				icon={<ProPageIcon />}
				value={I18n.t(`organization.diploma.type.${diploma.type}`)}
			/>
			<Info
				title={I18n.t("organization.diploma.mode.label")}
				icon={<MapIcon />}
				value={I18n.t(`organization.diploma.mode.${diploma.mode}`)}
			/>
		</Container>
	);
};

const Container = styled.div`
	@media ${desktop} {
		${row(0)}
	}
	@media ${mobile} {
		${stack(10)}
	}
`;

interface InfoProps extends React.HTMLAttributes<HTMLDivElement> {
	title: string;
	icon: JSX.Element;
	value: string;
}

export const Info: React.FC<InfoProps> = ({ title, icon, value, ...htmlProps }) => {
	return (
		<InfoContainer {...htmlProps}>
			<Primary>
				<b>{title}</b>
			</Primary>
			<Row gap={10} align="center">
				{icon} <PrimaryMedium>{value}</PrimaryMedium>
			</Row>
		</InfoContainer>
	);
};

const InfoContainer = styled.div`
	@media ${desktop} {
		${stack(10)};
		padding: 20px;

		svg {
			flex-shrink: 0;
		}

		&:not(:last-child) {
			border-right: 1px solid ${({ theme }) => theme.colors.lightergray};
		}
	}
	@media ${mobile} {
		> :first-child {
			display: none;
		}
	}
`;
